module.exports = __webpack_public_path__ + "img/hr-reactor-lights-grayscale.ded78a38.png";